import { useQuery, useInfiniteQuery } from "react-query";
import {
  fetchEvents,
  fetchEvent,
  EVENTS_LIMIT_PER_PAGE,
  EventSearchParams,
} from "lib/api";

const useEvents = (
  _categories: string[] | string,
  _searchParams: EventSearchParams = {},
  extraQueryParams = {}
) => {
  const searchParams = {
    ..._searchParams,
    limit: _searchParams.limit || EVENTS_LIMIT_PER_PAGE,
  };
  const categories = _categories
    ? Array.isArray(_categories)
      ? _categories
      : [_categories]
    : null;
  const Q = {
    slugs: categories,
    sparams: {
      ...searchParams,
    },
  };

  return useQuery(
    ["events", Q],
    ({ pageParam = 1 }) =>
      fetchEvents(categories, { ...searchParams, page: pageParam }),
    {
      enabled: !!categories && categories.length > 0,
      ...extraQueryParams,
    }
  );
};

const useEventsInfinite = (
  _categories,
  _searchParams: EventSearchParams = {},
  extraQueryParams = {}
) => {
  const searchParams = {
    ..._searchParams,
    limit: _searchParams.limit || EVENTS_LIMIT_PER_PAGE,
  };
  const categories = _categories
    ? Array.isArray(_categories)
      ? _categories
      : [_categories]
    : null;
  const Q = {
    slugs: categories,
    sparams: {
      ...searchParams,
    },
    infinite: true,
  };

  return useInfiniteQuery(
    ["events", Q],
    ({ pageParam = 1 }) =>
      fetchEvents(categories, { ...searchParams, page: pageParam }),
    {
      enabled: !!categories,
      ...extraQueryParams,
      getNextPageParam: (lastPage) => lastPage.nextPage,
    }
  );
};

type FetchEventError = {
  response?: {
    status: number;
    message: string;
  };
};

const useSingleEvent = (accountSlug, eventSlug) => {
  const Q = {
    accountSlug,
    eventSlug,
  };
  return useQuery(
    ["single-event", Q],
    () => fetchEvent(accountSlug, eventSlug),
    {
      enabled: !!accountSlug && !!eventSlug,
      retry: (failureCount: number, error: FetchEventError) => {
        if (error?.response?.status === 401) {
          return false;
        }
        if (failureCount <= 3) {
          return true;
        }
        return false;
      },
    }
  );
};

export { useEvents, useEventsInfinite, useSingleEvent };
